'use strict';

import angular from 'angular';
import uiRouter from 'angular-ui-router';

import slideshow from '../slideshow';
import constants from '../../constants';
import services from '../../services';

import saIntroVideo from './intro_video.directive';
import saIntroVideos from './intro_videos.directive';

import 'nls!./intro_videos.json';

const dependencies = [
  uiRouter,
  slideshow,
  constants,
  services
];

export default angular
  .module('common.introVideos', dependencies)
  .directive('saIntroVideo', saIntroVideo)
  .directive('saIntroVideos', saIntroVideos)
  .name;



// WEBPACK FOOTER //
// ./app/src/common/intro_videos/index.js